// Варіанти для Dropdown «Менеджер CRM» (таблиця користувачів і форма реєстрації).
//
// Список менеджерів береться з Orders.managers, куди CRM підтягується
// синхронізацією з запізненням. Нові менеджери приходять часто: у CRM їх уже
// створили, а в списку ще немає — тож дозволяємо ввести id руками. Зв'язок
// іде по id, тому коли синхронізація наздожене, ПІБ з'явиться сам.

// Підпис менеджера зі списку: «id · ПІБ», колишні (blocked) підписані
export const crmManagerLabel = (m) =>
  `${m.id} · ${m.full_name}${m.status === "blocked" ? " (колишній)" : ""}`;

// Введений id, якого немає в списку, — як окремий варіант. Інший текст — ні
export const customCrmManagerOption = (query) =>
  /^\d+$/.test(query) && Number(query) > 0
    ? { value: Number(query), label: `${query} · ще немає в списку CRM` }
    : null;
